/* Inline playback. Preparation is shared with the product story modules. */
(() => {
 const states=new Map(),motion=matchMedia('(prefers-reduced-motion:reduce)');
 function init(){
  for(const [v,s] of states)if(!v.isConnected){s.dispose();states.delete(v);}
  document.querySelectorAll('video[data-lazy-video]').forEach(v=>{
   if(states.has(v))return;
   let visible=false,pending=false,disposed=false;
   const play=(manual=false)=>{
    if(pending||(!manual&&(motion.matches||document.hidden||!visible)))return;
    window.FEMedia.prepare(v,true);pending=true;
    v.play().then(()=>{if(disposed||(!manual&&(!visible||document.hidden)))v.pause();}).catch(e=>{if(e.name!=='AbortError'&&visible)window.FEMedia.showPlay(v);}).finally(()=>pending=false);
   };
   const sync=()=>{if(visible&&!document.hidden&&!motion.matches&&v.hasAttribute('data-autoplay'))play();else v.pause();};
   const io=new IntersectionObserver(es=>{visible=es[0].isIntersecting&&es[0].intersectionRatio>=.2;sync();},{threshold:[0,.2]});io.observe(v);window.FEMedia.register(v);
   const button=v.parentElement.querySelector('button:not(.fe-video-retry)');const click=()=>play(true);button?.addEventListener('click',click);
   document.addEventListener('visibilitychange',sync);motion.addEventListener('change',sync);
   states.set(v,{dispose(){disposed=true;io.disconnect();v.pause();button?.removeEventListener('click',click);document.removeEventListener('visibilitychange',sync);motion.removeEventListener('change',sync);}});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);document.addEventListener('shopify:section:unload',()=>setTimeout(init,0));
})();
